// extracted by mini-css-extract-plugin
module.exports = {"container":"InvalidToken_container__2a-Kt","description":"InvalidToken_description__2ejXG","text":"InvalidToken_text__3XEKI","icon":"InvalidToken_icon__12lpd"};